// extracted by mini-css-extract-plugin
export default {"editForm":"style_editForm__kg9AP","desc":"style_desc__agjoy"};